import React, { useState } from "react";
import Axios from "../../axios/Axios";
import "../Dashboard/assets/css/app.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaCrown } from "react-icons/fa";
import {
  faBell,
  faUser,
  faWallet,
  faPowerOff,
  faTimesCircle,
  faDownload,

} from "@fortawesome/free-solid-svg-icons";
import "../Dashboard/DashboardLeftMenu";
import NotificationDropdown from "../Dashboard/profile/NotificationDropdown";
import NotificationMarquee from "../Admin/NotificationSetting/NotificationMarquee";
import { useNotifications } from "../Utils/useNotifications";
import { useEffect } from "react";
import { checkUserUrl } from "../Utils/Utils";
import { userloginDetails } from "../Utils/AdminAuth";
import { userProfile, NODE_HOST_URL_v1 } from "../Dashboard/api/Api";
import { userId, userToken, resellerId } from "../Utils/userAuth";

const DashboardHeader = (props) => {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const url = lStorage?.url;
  const URLLink = window.location.host;

  // Notification hook for top-header marquee
  const { marqueeNotifications, markNotificationAsShown } = useNotifications('top-header');
  const [currentMarquee, setCurrentMarquee] = useState(null);

  const isAdmin = userloginDetails();
  const IsAdminlogin = isAdmin.success;
  const parent_type = lStorage?.user?.parent_type;

  const [IsAdminLogin] = useState(IsAdminlogin);
  const [balance, setbalance] = useState(null);
  const [country_currency, setcountry_currency] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showRecharge, setShowRecharge] = useState(false);

  const allowedDomains = ["console.authkey.io", "localhost:3000"];
  const currentDomain = window.location.host;
  const canRecharge = parent_type !== "reseller" || resellerId === 14824 || resellerId === 12467;
  const showChannelPricing = allowedDomains.includes(currentDomain);

  // Handle marquee for top-header
  useEffect(() => {
    if (marqueeNotifications.length > 0 && !currentMarquee) {
      setCurrentMarquee(marqueeNotifications[0]);
    }
  }, [marqueeNotifications, currentMarquee]);

  const handleMarqueeClose = () => {
    if (currentMarquee) {
      markNotificationAsShown(currentMarquee);
      setCurrentMarquee(null);
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };



  useEffect(() => {
    let paramData = {
      user_id: userId,
      token: userToken,
      method: "retrieve"
    }
    userProfile(paramData).then((result) => {
      if (result.data.success === true) {
        setbalance(result.data.data[0].currency);
        setcountry_currency(result.data.data[0].country_currency);
      }
    })
    fetchPaymentStatus();
  }, []);

  const fetchPaymentStatus = async () => {
    try {
      const payload = {
        user_id: userId,
        token: userToken,
        method: "fetchPaymentStatus",
      };
      let { data } = await Axios.post(
        `${NODE_HOST_URL_v1}/reseller_payment_status`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      setShowRecharge(data.success === true);
    } catch (error) {
      setShowRecharge(false);
    }
  };


  const goBackToAdmin = () => {
    localStorage.removeItem("login");
    window.location = "/admin";
  };

  return (
    <>
      {/* Top Header Marquee Notification */}
      {currentMarquee && (
        <NotificationMarquee
          notification={currentMarquee}
        />
      )}

      <div style={{ margin: "2em", marginTop: currentMarquee ? "4em" : "2em" }}>
        <nav className="navbar dashboard-header navbar-expand navbar-light navbar-bg fixed-top">
          <div className="navbar-collapse collapse">
            <ul
              className="navbar-nav navheader navbar-align flex-wrap justify-content-end align-items-center"
              style={{ width: "100%" }}
            >

{(showChannelPricing && canRecharge) && (
              <li className="nav-item border-right">
                <Link
                  to="/dashboard/pricing-details"
                  className="glow-badge"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#6f42c1", // violet
                    background: "#f3e8ff",
                    padding: "6px 12px",
                    borderRadius: "20px",
                    marginRight: "4px",
                    cursor: "pointer",
                    textDecoration: "none",
                    transition: "all 0.3s ease"
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#e9d5ff")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "#f3e8ff")
                  }
                >
                  <FaCrown size={14} color="#6f42c1" />
                  Plans & Pricing
                </Link>
              </li>
            )}

            <li
              style={{ position: "relative" }}
              className="nav-item border-right"
            >
              <a
                style={{ color: "#3b7ddd" }}
                className="nav-icon"
                href={(parent_type !== "reseller" || resellerId === 14824 || resellerId === 12467) &&
                  `${checkUserUrl(URLLink) === true
                    ? "/dashboard/transaction-payment"
                    : "/dashboard/transaction-history"
                  }`}
              >
                <div className="position-relative wallet">
                  <FontAwesomeIcon icon={faWallet} className="mr-2" />{" "}
                  <span className="wallet-price">
                    {" "}
                    {country_currency} : {balance}
                  </span>
                </div>
                {(parent_type !== "reseller" || resellerId === 14824 || resellerId === 12467 ? true : showRecharge) &&
                  <span
                    style={{
                      fontSize: "8px",
                      fontWeight: 'bold',
                      color: '#6C757D',
                      position: "absolute",
                      left: 50 + "%",
                    }}
                  >
                    Recharge
                  </span>}
                   {/* {(parent_type !== "reseller" || resellerId === 14824 || resellerId === 12467) &&
                  <span
                    style={{
                      fontSize: "8px",
                      fontWeight: 'bold',
                      color: '#6C757D',
                      position: "absolute",
                      left: 50 + "%",
                    }}
                  >
                    Recharge
                  </span>} */}
              </a>
            </li>

            <li className="nav-item border-right">
              <Link
                className="nav-icon"
                to="/dashboard/download-centre"
                id="alertsDropdown"
                data-toggle=""
              >
                <div className="position-relative">
                  <FontAwesomeIcon icon={faDownload} />
                </div>
              </Link>
            </li>
            {checkUserUrl(url) && (
              <li className="nav-item border-right">
                {/* <Link
                className="nav-icon"
                to="/dashboard/notification"
                id="alertsDropdown"
                data-toggle=""
              >
                <div className="position-relative">
                  <FontAwesomeIcon icon={faBell} color="red" />
                  <span className="indicator">1</span>
                </div>
              </Link> */}
                <div className="nav-item border-right position-relative">
                  <div className="nav-icon" onClick={toggleDropdown} style={{ cursor: "pointer" }}>
                    <div className="position-relative">
                      <FontAwesomeIcon icon={faBell} color="red" />
                      <span className="indicator">1</span>
                    </div>
                  </div>
                  {showDropdown && <NotificationDropdown />}
                </div>

              </li>
            )}
            <li className="nav-item border-right">
              <Link
                className="nav-icon dropdown-toggle"
                to="/dashboard/my-profile"
                id="alertsDropdown"
              >
                <span style={{ cursor: "pointer" }} className="">
                  <div className="position-relative">
                    <FontAwesomeIcon icon={faUser} />
                  </div>
                </span>
              </Link>
            </li>

            <li className="nav-item">
              <Link
                className="nav-icon dropdown-toggle"
                to="/logout"
                id="alertsDropdown"
              >
                <span style={{ cursor: "pointer" }} className="">
                  <div className="position-relative">
                    <FontAwesomeIcon icon={faPowerOff} />
                  </div>
                </span>
              </Link>
            </li>

            {IsAdminLogin ? (
              <li className="nav-item dropdown">
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => goBackToAdmin()}
                  className="nav-icon"
                >
                  <div color="red" className="position-relative">
                    <FontAwesomeIcon color="red" icon={faTimesCircle} />
                  </div>
                </span>
              </li>
            ) : null}
          </ul>

        </div>
      </nav>
    </div>
    </>
  );
};

export default DashboardHeader;
